"use client";

import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
  cn,
} from "@workspace/frontend-ui";
import { Children, useState } from "react";
import useAutoRotate from "../../shared/useAutoRotate";

type Props = {
  isMobile: boolean;
  dir?: "ltr" | "rtl";
  delay: number;
};

const PandaBannerView: FC<Props> = ({
  children,
  isMobile,
  dir = "ltr",
  delay,
}) => {
  const [api, setApi] = useState<CarouselApi>();
  const { selected, goTo } = useAutoRotate(api, delay);
  const items = Children.toArray(children);

  if (!isMobile) {
    return (
      <div
        data-testid="desktop-bitcasino-loggedin-banner"
        className="flex justify-between gap-4"
      >
        {items}
      </div>
    );
  }

  return (
    <div data-testid="mobile-bitcasino-loggedin-banner" className="-mx-4 px-4">
      <Carousel setApi={setApi} opts={{ direction: dir, loop: true }}>
        <CarouselContent className="-ml-3">
          {items.map((item, index) => (
            <CarouselItem
              // biome-ignore lint/suspicious/noArrayIndexKey: static server-provided list
              key={index}
              className="w-fit basis-auto rounded-xl pl-3"
            >
              {item}
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      <div className="mt-4 flex justify-center gap-2">
        {items.map((_, index) => (
          <button
            // biome-ignore lint/suspicious/noArrayIndexKey: static server-provided list
            key={index}
            type="button"
            aria-label={`Go to slide ${index + 1}`}
            onClick={() => goTo(index)}
            className={cn(
              "h-2 w-2 rounded-full bg-muted-foreground/40",
              index === selected && "bg-muted-foreground",
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default PandaBannerView;
